var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from 'react';
import styled from 'styled-components';
import { device } from '../../breakpoints';
var LOGOS_URL = "https://assets.asurion-ui.my.asurion53.com/images/logos";
var StyledImage = styled.img(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: block !important;\n  height: 48px;\n\n  @media ", " {\n    height: 40px;\n  }\n"], ["\n  display: block !important;\n  height: 48px;\n\n  @media ", " {\n    height: 40px;\n  }\n"])), device.laptop);
export var LogoImage = function (props) {
    return (React.createElement(StyledImage, __assign({}, props, { src: "".concat(LOGOS_URL, "/").concat(props.logo), alt: props.alt || 'logo' })));
};
var templateObject_1;
